import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

import type { Project } from './projects';

type PublishProjectOptions = {
  mutationConfig?: MutationConfig<typeof publishProject>;
};

type UnpublishProjectOptions = {
  mutationConfig?: MutationConfig<typeof unpublishProject>;
};

const publishProject = (id: Project['id']) => {
  return extractData(api.projects({ id }).publish.put());
};

export const usePublishProject = ({ mutationConfig }: PublishProjectOptions = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: publishProject,
  });
};

const unpublishProject = (id: Project['id']) => {
  return extractData(api.projects({ id }).unpublish.put());
};

export const useUnpublishProject = ({ mutationConfig }: UnpublishProjectOptions = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: unpublishProject,
  });
};
